/* eslint-disable */
import Vue from 'vue';
import { sync } from 'vuex-router-sync';

import ShardsVue from 'shards-vue';

// Styles
import 'bootstrap/dist/css/bootstrap.css';
import '@/assets/scss/shards-dashboards.scss';
import '@/assets/scss/date-range.scss';

// Core
import App from './App.vue';
import store from './store';
import router from './router'


ShardsVue.install(Vue);

Vue.config.productionTip = false;
Vue.prototype.$eventHub = new Vue();

sync(store, router);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
